import { Box, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { CopyTextIcon } from './cardActions/copyText';
import { AlternateEmailOutlined } from '@mui/icons-material';
import { Color } from 'shared/utils/colors';

export const UserEmail = ({
  email,
  setOpenSnackbar,
}: {
  email: string;
  setOpenSnackbar: (open: boolean) => void;
}): ReactElement => {
  return (
    <Box
      display='flex'
      alignItems='center'
      sx={{
        position: 'relative',
        '&:hover': {
          '& .copy-icon': {
            opacity: 1,
          },
          '& .email-text': {
            color: Color.primaryOrangeDark,
          },
        },
      }}
    >
      <Typography
        className='email-text'
        sx={{
          transition: 'color 0.2s',
        }}
        fontWeight={300}
        fontSize={14}
      >
        {email}
      </Typography>
      <CopyTextIcon value={email} setOpenSnackbar={setOpenSnackbar} />
    </Box>
  );
};
